import { ITabData } from '../types';

export function mapClausesToTabs(clauses: HTMLElement[]) {
  if (clauses.length < 1) {
    return [];
  }

  return clauses
    .map((tabElement: HTMLElement) => {
      const [anchor, label = ''] = (tabElement.dataset.navTab || '/').split('/');

      return {
        label,
        anchor,
        point: tabElement.offsetTop,
      };
    })
    .filter((clause: ITabData) => Boolean(clause.label && clause.anchor))
    .sort((a, b) => a.point - b.point);
}
